function GoogleTag_Handler(data, options) {
  try {
    data.ignore_for_GTM = true;
    var event_name = data.event || data.events;
    gtag('event', event_name, data);
    return {
      status: 'success',
      message: "Google Tag event ".concat(event_name, " processed successfully"),
      data: data
    };
  } catch (err) {
    return {
      status: 'error',
      message: "GoogleTag Handler failed to capture event. Error: ".concat(err.message),
      data: data
    };
  }
}

module.exports = {
  GoogleTag_Handler: GoogleTag_Handler
};